import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import $ from "jquery";
import { getShipment } from "../../../store/utility";
import { constants } from "../../../firebase/firestoreNameSpaces";

class OrdersCard extends Component {
  constructor(props) { 
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleDoneOrder = this.handleDoneOrder.bind(this);
    this.handleCancelOrder = this.handleCancelOrder.bind(this);
    this.handlePayProfessional = this.handlePayProfessional.bind(this);
    this.handleRefund = this.handleRefund.bind(this);

    this.state = {
        Status:"",
        StatusType:""
    };
  }

  async componentDidMount() {
    let {Status, StatusType} = await getShipment(this.props.product,this.props.orders)

    this.setState({
       orders: this.props.orders,
        Status,
        StatusType
    });
  }

  handleChange(e) {
    let { name, value } = e.target;
    let orders = this.state.orders;
    orders[name] = value;
    this.setState({ orders });
  }

  handleDoneOrder(e, order) {
    e.preventDefault();
    this.props.onClickDoneOrder(order);
    $(".modal-backdrop").remove();
  }

  handleCancelOrder(e,order) {
    e.preventDefault();
    let receipt = e.target.id;
    this.props.onClickCancelOrder(order);
    $(".modal-backdrop").remove();
  }

  handlePayProfessional(e) {
    e.preventDefault();
    let receipt = e.target.id;
    this.props.onClickPayProfessional(receipt);
    $(".modal-backdrop").remove();
    $("button#adminPayProfessional.btn.btn-warning").click();
  }

  handleRefund(e) {
    e.preventDefault();
    let receipt = this.props.orders.receipt;
    let waybill = this.props.product.waybill;
    this.props.onClickRefund(receipt,waybill);
    $(".modal-backdrop").remove();
    $("button#adminRefundOrderBtn.btn.btn-warning").click();
  }

  getDateFromTime = (time) => {
    let d = new Date(time);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };
  getProfessional = (order, name) => {
    if (order.professional) {
      return order.professional[name];
    }
    return "";
  };
  
  getRefundButton = ()=>{
    try{

      let order = this.props.orders;  //single order
      let product = this.props.product;
      let waybill = product.waybill;
      let isRefunded = order.packageStatus[waybill].isRefunded;
      let {Status, StatusType} = this.state;
      let sc = StatusType+"_"+Status;
      let productId = product.variantId?product.variantId:product.id;
      let refundbtn = (<button
        className={`btn p-0 m-0 btn-secondary ${this.props.refundBtnDisplay}`}
        data-toggle="modal"
        data-target={`#rfd${productId + this.props.uniqueModal}`}
        // disabled={orders.refund === "done"}
      >
        Refund
      </button>)
  
       
          if(isRefunded){
            return <h5>Refunded</h5>
          }
        

      if(sc=="DL_RTO"){

          if(!isRefunded&&order.payment_mode===constants.PAYMENT_ONLINE_ORDER){
            return refundbtn;
          }else{
            return null;
          }
         
      }else if(sc=="DL_DTO"){

          if(isRefunded){
            return <h5>Refunded</h5>
          }else{
            return refundbtn;
          }

      }else{
        return null
      }

    }catch(error){
      return null;
    }
   

  }
 
  render() {
    let orders = this.props.orders;  //single order
    let product = this.props.product;
    let address = orders.address;
    let productId = product.variantId?product.variantId:product.id;
    let productIndex = this.props.productIndex;
   
    // let professional = orders.professional;
    return (
      <tr>
        <th scope="row">
          {
            productIndex==0?(
              `${orders.receipt} (${orders.payment_mode})`
            ):null
          }
          
        </th>

        <td>
          {product.waybill}
        </td>

        <td>{address.firstname+" "+ address.lastname}</td>
        <td>{address.phone}</td>
        <td>
          <button
            className="btn p-0 m-0 btn-primary"
            data-toggle="modal"
            data-target={`#oi${productId + this.props.uniqueModal}`}
          >
            View
          </button>
        </td>
       
        <td>
          <button
            className={`btn p-0 m-0 mr-2 btn-success ${this.props.btnDisplay}`}
            data-toggle="modal"
            data-target={`#od${productId + this.props.uniqueModal}`}
          >
            Done
          </button>
          <button
            className={`btn p-0 m-0 btn-secondary ${this.props.btnDisplay}`}
            data-toggle="modal"
            data-target={`#oc${productId+ this.props.uniqueModal}`}
          >
            Cancel
          </button>
        {/* <h5 className="m-0 ml-2 d-inline">
          {orders.orderStatus.toUpperCase()}
        </h5> */}
          {/* {this.props.isAdmin ? (
            <React.Fragment>
              {orders.professionalPaymentStatus === "done" ? (
                <h5>Paid</h5>
              ) : (
                <button
                  className={`btn p-0 m-0 btn-success ${this.props.payBtnDisplay}`}
                  data-toggle="modal"
                  data-target={`#pp${orders.receipt + this.props.uniqueModal}`}
                  // disabled={orders.professionalPaymentStatus === "done"}
                >
                  Pay Professional
                </button>
              )}
            </React.Fragment>
          ) : null} */}
 

          {this.props.isAdmin ? ( 
            <React.Fragment>
              {this.getRefundButton()}
            </React.Fragment>
          ) : null} 



          {/* ----------------------- Order Details view Modal starts ----------------------- */}
          <div
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            id={`oi${productId + this.props.uniqueModal}`}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Waybill: {product.waybill}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="card-text">
                    Order Id: {orders.receipt}
                  
                  </p>
                  
                  <p className="card-text">
                    <b><span >
                            {product.productTitle}(
                            {`${product.quantity}x${product.salePrice}`}
                            )&nbsp;
                          </span></b>
                  </p>

                  {orders.coupon && (
                    <p>
                      Coupon Applied:
                      {` ${orders.coupon.couponName}(${orders.coupon.netDiscount})`}
                    </p>
                  )}

                  {orders.delivery&&(<p className="card-text">
                    Delivery Charge: {orders.delivery}{" "}
                  
                  </p>
                  )}
                  <p className="card-text">
                    Total: ₹  {orders.finalPrice}
                  </p>
                  <p className="card-text">
                    Order Placed On: {this.getDateFromTime(orders.timestamp)}
                  </p>
                  {/* <p className={`card-text ${this.props.display}`}>
                    Accepted By:{" "}
                    {this.getProfessional(orders, "professionalName")} -{" "}
                    {this.getProfessional(orders, "professionalContact")}
                  </p> */}
                  <p className="card-text">
                    Address: 
                   { ` ${address.streetaddress}, near ${address.landmark}, ${address.state}, ${address.city} - ${address.pincode}`}
                  </p>
                  {/* <p className="card-text">
                    Customer Payment: {orders.paymentStatus}
                  </p> */}
                  {/* <p className="card-text">
                    Professional Payment: 
                  {orders.professionalPaymentStatus}
                  </p> */}
                  {/* <p className="card-text">
                    Order Complete Pin: 
                    {orders.pin}
                    </p> */}
                </div>
              </div>
            </div>
          </div>
          {/* ----------------------- Order Details view Modal ends ----------------------- */}


          {/* ----------------------- Order Done Modal starts ----------------------- */}
          {/* <div
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            id={`od${orders.receipt + this.props.uniqueModal}`}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Irreversible operation
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>
                    Are you sure you want to Mark '{orders.receipt}' as done
                    with following details of the professional ?
                  </p>
                  <form onSubmit={(e) => this.handleDoneOrder(e, orders)}>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label htmlFor="name">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          value={orders.professionalName}
                          name="professionalName"
                          onChange={(e) => this.handleChange(e, orders.receipt)}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label htmlFor="Phone">Contact</label>
                        <input
                          type="text"
                          name="professionalContact"
                          className="form-control"
                          maxLength="13"
                          id="Phone"
                          value={orders.professionalContact}
                          onChange={(e) => this.handleChange(e, orders.receipt)}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <label htmlFor="inputAccount">Account Number</label>
                        <input
                          type="number"
                          className="form-control"
                          id="inputAccount"
                          placeholder="Enter Account Number"
                          value={orders.professionalAccount}
                          name="professionalAccount"
                          onChange={(e) => this.handleChange(e, orders.receipt)}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label htmlFor="name">IFSC Code</label>
                        <input
                          type="text" 
                          className="form-control"
                          id="professionalIfsc"
                          placeholder="Enter IFSC code"
                          value={orders.professionalIfsc}
                          name="professionalIfsc"
                          onChange={(e) => this.handleChange(e, orders.receipt)}
                          required
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-secondary mr-2"
                        id={orders.receipt}
                        disabled={this.props.doneOrderBtnLoading}
                      >
                        {this.props.doneOrderBtnLoading ? "Confirming" : "Yes"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning mr-4"
                        data-dismiss="modal"
                      >
                        No
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div> */}
          {/* ----------------------- Order Done Modal ends ----------------------- */}

          
          {/* ----------------------- Order Cancel Modal starts ----------------------- */}
          {/* <div
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            id={`oc${orders.receipt + this.props.uniqueModal}`}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Irreversible operation
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>
                    Are you sure you want to Cancel '{orders.receipt}' order ?
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    id={orders.receipt}
                    onClick={(e) => {
                      this.handleCancelOrder(e,orders);
                      // document.getElementById("adminOrderCancel").click();
                    }}
                    disabled={this.props.cancelOrderBtnLoading}
                  >
                    {this.props.cancelOrderBtnLoading ? "Cancelling" : "Yes"}
                  </button>
                  <button
                    type="button"
                    id={"adminOrderCancel"+orders.receipt}
                    className="btn btn-warning"
                    data-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          {/* ----------------------- Order Cancel Modal ends ----------------------- */}
          {/* ----------------------- Pay Professional Modal starts ----------------------- */}
          {/* <div
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            id={`pp${productId + this.props.uniqueModal}`}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Irreversible operation
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body text-center">
                  <p>
                    Account No:{" "}
                    {this.getProfessional(orders, "professionalAccount")}
                  </p>
                  <p>
                    IFSC: {this.getProfessional(orders, "professionalIfsc")}
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    className={`btn btn-success ${this.props.payBtnDisplay}`}
                    id={productId}
                    onClick={(e) => {
                      this.handlePayProfessional(e);
                      document.getElementById("adminPayProfessional").click();
                    }}
                    disabled={this.props.professionalPaymentLoading}
                  >
                    {this.props.professionalPaymentLoading ? "Saving" : "Pay"}
                  </button>
                  <button
                    type="button"
                    id="adminPayProfessional"
                    className="btn btn-warning"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          {/* ----------------------- Pay Professional Modal ends ----------------------- */}
          {/* ----------------------- Refund Modal starts ----------------------- */}

          <div
            className="modal fade"
            tabIndex="-1"
            role="dialog"
            id={`rfd${productId+ this.props.uniqueModal}`}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Irreversible operation
                  </h5>
                  <button
                    type="button"
                    id="adminRefundOrder"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body text-center">
                  <p>
                    Are you sure you want to mark <b>{product.waybill}</b> as
                    refunded?
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-success"
                    id={productId}
                    onClick={(e) => {
                      this.handleRefund(e);
                      //   document
                      //     .getElementById("adminRefundOrder")
                      //     .trigger("adminRefundOrder");
                    }}
                    disabled={this.props.refundBtnLoading}
                  >
                    {this.props.refundBtnLoading ? "Saving" : "Yes"}
                  </button>
                  <button
                    type="button"
                    id="adminRefundOrderBtn"
                    className="btn btn-warning"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* ----------------------- Refund Modal ends ----------------------- */}
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    doneOrderBtnLoading: state.orders.doneOrderBtnLoading,
    cancelOrderBtnLoading: state.orders.cancelOrderBtnLoading,
    professionalPaymentLoading: state.orders.professionalPaymentLoading,
    refundBtnLoading: state.orders.refundBtnLoading,
    isAdmin: state.auth.admin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickDoneOrder: (order) => dispatch(actions.onClickDoneOrder(order)),
    onClickCancelOrder: (receipt) =>
      dispatch(actions.onClickCancelOrder(receipt)),
    onClickPayProfessional: (receipt) =>
      dispatch(actions.onClickPayProfessional(receipt)),
    onClickRefund: (receipt,waybill) => dispatch(actions.onClickRefund(receipt,waybill)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(OrdersCard, Axios));
